module.exports = __webpack_public_path__ + "static/media/remindersbell.1a2d015e.svg";